import { secretStorage } from "config"
import { isEmpty } from "lodash"
import { useDispatch } from "react-redux"
import { actions } from "store"
import { application, pulldowns } from "."
import { useSelector } from "react-redux"
import { setRolesInAxiosHeader } from "config/axiosConfig"
import { useQueryClient } from "@tanstack/react-query"

const useSetAppData = () => {
    const dispatch = useDispatch()
    const { roleIndex } = useSelector(state => state.user)

    return (user_data) => {
        if (!isEmpty(user_data)) {
            const { affiliation_groups, affiliations, grades } = user_data?.[roleIndex]?.user_data || {}
            dispatch(actions.setGroups(affiliation_groups))
            dispatch(actions.setAffiliations(affiliations))
            dispatch(actions.setGrades(grades))
        }
    }
}

const useInitAppData = () => {
    const dispatch = useDispatch()
    const setAppData = useSetAppData()
    const setPulldownDefaultValue = pulldowns.useDefaultValue()

    return (nUser) => {
        const currentUser = nUser || secretStorage.getItem("user")
        const { user_data, default_user_roles } = currentUser || {}
        dispatch(actions.setUser(currentUser))
        setAppData(user_data)
        setPulldownDefaultValue(currentUser)
    }
}

export const useCleanAppData = () => {
    const dispatch = useDispatch()

    return () => {
        dispatch(actions.setGroups(null))
        dispatch(actions.setGroups(null))
        dispatch(actions.setAffiliations(null))
        dispatch(actions.setGrades(null))
        dispatch(actions.setSchoolClasses(null))
        dispatch(actions.setLearningGroups(null))
        dispatch(actions.setHeaderFilters({}))
    }
}

const useRoleIndex = () => {
    const dispatch = useDispatch()
    const queryClient = useQueryClient()
    const { user_data } = secretStorage.getItem("user")
    const { schoolYear } = useSelector(state => state.general)

    return (roleIndex) => {
        setRolesInAxiosHeader(user_data?.[roleIndex]?.user_roles, schoolYear)
        dispatch(actions.setRoleIndex(roleIndex))
        queryClient.resetQueries()
    }
}

export default { useRoleIndex, useInitAppData, useCleanAppData, useSetAppData }